import { AlertCircle } from 'lucide-react';
import { Item, ItemDescription, ItemMedia } from '@/components/ui/item.tsx';

interface LeadActionErrorProps {
  readonly message: string;
}

export function LeadActionError({ message }: LeadActionErrorProps) {
  return (
    <div className="absolute -top-7 w-full max-w-sm flex justify-center z-10 pointer-events-none">
      <Item
        variant="outline"
        className="animate-in fade-in slide-in-from-bottom-1 w-fit min-h-0 flex-nowrap px-2 py-1 rounded shadow-sm"
        role="alert"
      >
        <ItemMedia>
          <AlertCircle className="h-3.5 w-3.5" />
        </ItemMedia>
        <ItemDescription>{message}</ItemDescription>
      </Item>
    </div>
  );
}
